import BajajFooter from "./BajajFooter";
import TataFooter from "./TataFooter";
import { useSelector } from "react-redux";

const Footer = () => {
  const {
    frontendData: { tenant },
  } = useSelector(state => state.frontendBoot);
  return tenant?.name === "TMIBASL" ? (
    <TataFooter />
  ) : tenant?.name === "Bajaj" ? (
    <BajajFooter />
  ) : (
    <></>
  );
};

export default Footer;
